export const viA = {
    // A
    account: {
        form: {
            account: 'Tài khoản',
            newPassword: 'Mật khẩu mới',
            resetTitle: 'Đặt lại Mật khẩu'
        }
    },
    area: {
        list: { title: 'Danh sách khu vực', unit: 'khu vực' },
        form: {
            name: 'Tên khu vực',
            select: 'Chọn khu vực',
            active: 'Hoạt động'
        }
    },
    about: {
        title: 'Thông tin spa',
        basicinformation: 'Thông tin cơ bản',
        Workshiftinformation: 'Thông tin ca làm việc',
        systemconfiguration: 'Cấu hình hệ thống',
        spaName: 'Tên Spa',
        branchinformation: 'Thông tin chi nhánh'
    },
    absence: {
        list: {
            code: 'Mã đơn',
            fullName: 'Tên KH',
            joinedDate: 'Ngày làm',
            startTime: 'Thời gian bắt đầu',
            endTime: 'Thời gian kết thúc',
            userCode: 'Mã NV',
            userFullName: 'Tên NV',
            reason: 'Lý do nghỉ',
            approvedStatus: 'Trạng thái phê duyệt',
            isCancel: 'Đã hủy ca',
            isCancelAwait: 'Chờ duyệt hủy',
            address: 'Địa chỉ',
            servicePackageName: 'Gói DV'
        }
    }
};
